import { Translation } from '@ps/web-shared-components';
import { useEffect } from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';

import RMFSSN9 from '../RMFSSN9/RMFSSN9';

import {
  TXTCLI_Confirm_your_SSN,
  TXTCLI_Enter_the_first_5_digits_of_yo_ELL,
  TXTWCL_This_is_a_regulatory_requireme_ELL
} from './RMFSSNConfirmation.messages.json';

const RMFSSNConfirmation: React.FC = () => {
  const { data } = useWizardContext();

  useEffect(() => {
    data.SSNConfirmationRequired = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RMFSSN9
      page={RMFSSNConfirmation}
      title={TXTCLI_Confirm_your_SSN}
      pageTopTitle={TXTCLI_Confirm_your_SSN}
      pageTopSubtitle={
        <>
          <Translation {...TXTCLI_Enter_the_first_5_digits_of_yo_ELL} />
          <Translation {...TXTWCL_This_is_a_regulatory_requireme_ELL} />
        </>
      }
    />
  );
};

RMFSSNConfirmation.displayName = 'RMFSSNConfirmation';

export default RMFSSNConfirmation;
